import { useIntl } from "react-intl";

import { PersistentDrawer } from "@/components/Drawer/PersistentDrawer";
import { SwipeableDrawer } from "@/components/Drawer/SwipeableDrawer";
import { TripTourPlan } from "@/features/trips/components/bookingFlow/tripDetails/TripTourPlanCard";
import type { TripDetails } from "@/features/trips/types/types";
import { formatCurrency } from "@/utils/currency";

type TripTourDrawerProps = {
  trip: TripDetails;
  open: boolean;
  onClose: () => void;
  children?: React.ReactNode;
};

export function TripTourDrawer({
  trip,
  open,
  onClose,
  children,
}: TripTourDrawerProps) {
  const intl = useIntl();

  return (
    <SwipeableDrawer open={open} onClose={onClose}>
      <div className="pb-[var(--drawer-height,0)]">
        <h2 className="font-medium">
          {intl.formatMessage(
            {
              id: "trips.tours.drawer.title",
              defaultMessage: "Tour Program in {city}",
            },
            { city: trip.cities },
          )}
        </h2>
        <p className="mb-4 text-sm text-text-tertiary">
          {intl.formatMessage({
            id: "trips.tours.drawer.subtitle",
            defaultMessage:
              "Discover the details of the daily tours waiting for you",
          })}
        </p>

        <TripTourPlan itineraries={trip.itineraries} />
      </div>

      <PersistentDrawer open={open}>
        <dl className="mb-4 flex items-center justify-between gap-2 text-sm">
          <dt>
            {intl.formatMessage({
              id: "trips.tours.drawer.priceNotice",
              defaultMessage: "City tour prices per person",
            })}
          </dt>
          <dd className="text-end text-base font-bold">
            <bdi>+{formatCurrency(trip.tourPrice)}</bdi>
          </dd>
        </dl>

        <div className="flex gap-2">{children}</div>
      </PersistentDrawer>
    </SwipeableDrawer>
  );
}
